export default "__VITE_ASSET__DErvNMZR__"